import React from "react";
import { IonButton } from "@ionic/react";
import { IDashboardCard } from "@interfaces/Interfaces";
import "./HomeComponents.css";

const DashboardCard = (props: IDashboardCard) => {
  const shouldOverflow = (value: string): boolean => {
    const array = ["Summary of Work & Personal Statement"];

    return array.includes(value) || typeof props.isProfile !== "undefined";
  };

  return (
    <div className={`dashboardCard ${props.className ? props.className : ""}`}>
      <div className="dashboardHeader">
        <div className="dashboardCardTitleContainer">
          <div className="dashboardCardTitle">
            {props.title}
            {props.subtitle && <div className="dashboardCardSubtitle">{props.subtitle}</div>}
          </div>
          {props.newFeature && (
            <div
              className={`developmentProgressPill newFeaturePill ${shouldOverflow(props.title) ? "developmentProgressPillOverflow" : ""}`}
            >
              {"NEW"}
            </div>
          )}
          {props.inProgress && (
            <div
              className={`developmentProgressPill ${shouldOverflow(props.title) ? "developmentProgressPillOverflow" : ""}`}
            >
              {"IN PROGRESS"}
            </div>
          )}
          {props.comingSoon && (
            <div
              className={`developmentProgressPill ${shouldOverflow(props.title) ? "developmentProgressPillOverflow" : ""}`}
            >
              {"COMING SOON"}
            </div>
          )}
        </div>
        {props.sideButton && (
          <IonButton
            mode="ios"
            className="dashboardSideButton"
            onClick={() => props.buttonClicked?.()}
          >
            {props.sideButtonText || "Edit"}
          </IonButton>
        )}
      </div>
      <div className="dashboardCardText">{props.children}</div>
    </div>
  );
};

export default DashboardCard;
